import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { userPropTypes } from '../../../prop-types'
import Block from '../../common/Block'
import Divider from '../../common/Divider'
import Podium from '../Podium'
import RankingRow from '../RankingRow'
import { getPositionDiff } from './utils'

const PODIUM_LENGTH = 3
const BORDER_RADIUS = 6

const Container = styled.div`
    max-width: 400px;
    margin: 0 auto;
    overflow: hidden;
`

const Leaderboard = ({
    leaderboard,
    totalUsers,
    me,
}) => {
    const { t } = useTranslation()

    const winnerIds = leaderboard.map((user) => user.id)
    const meWinner = me != null && winnerIds.includes(me.id)
    let myPosition = null

    // In case logged in user is outside ranking (we only consider top 10 users),
    // add it to the tail and estimate its position
    if (me != null && !meWinner) {
        const { length } = leaderboard
        const lastUser = leaderboard[length - 1]
        myPosition = length + getPositionDiff(totalUsers, lastUser.trees, me.trees) + 1
    }

    const winners = leaderboard.slice(0, PODIUM_LENGTH) // right index not included
    const rest = leaderboard.slice(PODIUM_LENGTH)

    return (
        <Container>
            <Podium
                winners={winners}
                me={me}
            />
            <Block
                ph="XXL"
                bgColor="white"
                style={{
                    borderBottomLeftRadius: `${BORDER_RADIUS}px`,
                    borderBottomRightRadius: `${BORDER_RADIUS}px`,
                }}
            >
                {rest.map((user, index) => {
                    const isMe = meWinner && user.id === me.id
                    return (
                        <React.Fragment key={user.id}>
                            {index > 0 && <Divider color="lightGrey3" />}
                            <RankingRow
                                user={user}
                                position={PODIUM_LENGTH + index + 1}
                                isMe={isMe}
                                title={isMe ? t('leaderboardComp.youAreHere.title') : user.profile?.nickname || 'Incognito'}
                            />
                        </React.Fragment>
                    )
                })}
                {myPosition && (
                    <React.Fragment key={me.id}>
                        <Divider color="lightGrey3" />
                        <RankingRow
                            user={me}
                            position={myPosition}
                            isMe
                            title={t('leaderboardComp.youAreHere.title')}
                        />
                    </React.Fragment>
                )}
            </Block>
        </Container>
    )
}

Leaderboard.propTypes = {
    leaderboard: PropTypes.arrayOf(userPropTypes),
    totalUsers: PropTypes.number.isRequired,
    me: userPropTypes,
}

Leaderboard.defaultProps = {
    leaderboard: [],
    me: null,
}

export default Leaderboard
